import React, { Component } from "react";
import { Redirect } from 'react-router-dom'

import LoaderButton from "../components/LoaderButton";
import config from "../config";
import { API } from "aws-amplify";
import { s3Upload } from "../libs/awsLib";

export default class SubmitPresentation extends Component {

  constructor(props){
    super(props);
    this.file = null;

    this.state = {
      errorMsg: "",
      successMsg: "",
      isLoading: null,
      fullname: "",
      email:"",
      title:"",
      attachment:""

    }

  }

  validateForm(){
    return true;
  }

  handleIsVideoChange = event => {

    this.setState({
      [event.target.id]: !this.state[event.target.id+"UI"]+"",
      [event.target.id+"UI"]: !this.state[event.target.id+"UI"]

    });

  }

  handleChange = event => {
    event.preventDefault();
    this.setState({
      [event.target.id]: event.target.value,
      errorMsg: ""
    });
  }

  handleFileChange = event => {
    this.file = event.target.files[0];
    this.files = event.target.files;
  }

  handleSubmit = async event => {
    event.preventDefault();

    if(this.state.fullname.length === 0){
        this.setState({errorMsg: "Your name cannot be empty"});
        return;
    }

    if(this.state.email.length === 0){
        this.setState({errorMsg: "Your email cannot be empty"});
        return;
    }


    if(this.state.title.length === 0){
        this.setState({errorMsg: "Presentation Topic cannot be empty"});
        return;
    }

    if(!this.files || this.files.length === 0){
      this.setState({errorMsg: "Please upload your presentation."});
      return;
    }


    if(this.state.isVideo === "true" && this.files && this.files.length > 1){
      this.setState({errorMsg: "If it's a video you can only select one video file."});
      return;
    }

    if(this.state.isVideo === "true" && this.files && !this.files[0].name.endsWith(".mp4")){
      this.setState({errorMsg: "Please upload a MP4 format videos. Covert to MP4 here -> https://www.zamzar.com/"});
      return;
    }


    try{
      const attachments = [];
      if(this.files){
        for(var i = 0; i < this.files.length; i++){
            if(this.files[i].size > config.MAX_ATTACHMENT_SIZE){
              this.setState({errorMsg: "Please pick a file smaller than 20MB"});
              return;
            }
        }

       this.setState({ isLoading: true });

        //as all the files are in within our size limit upload them
        for(var i = 0; i < this.files.length; i++){
            // if(this.files[i].size < config.MAX_ATTACHMENT_SIZE){
               attachments[i] = this.files[i] ? await s3Upload(this.files[i]) : null;
            // }
        }


      }

        await this.uploadPresentation({
             attachment: attachments.length > 0 ? attachments.join() : "",
             email: this.state.email,
             title: this.state.title,
             fullname: this.state.fullname,
             isVideo: this.state.isVideo,

        });

        // const data = new FormData();
        // data.append('file', this.files[0]);
        // data.append('email', this.state.email);
        //
        // await this.uploadPresentation(data);

        // await this.uploadPresentation({
        //      file_uploaded: this.files[0],
        //      email: this.state.email,
        //      title: this.state.title,
        //      fullname: this.state.fullname,
        //      isVideo: this.state.isVideo,
        //
        // });


      this.setState({isLoading: false, successMsg: "Thanks for your submission. We will get back to you soon."})


    }catch(e){

      console.log(JSON.stringify(e));
      this.setState({isLoading: false, errorMsg: e.message});
    }
  }


  uploadPresentation(blog){

    return API.post("retnetindia", "/presentations", {
      body: blog
    })
  }

  getErrorElement(){
     return this.state.errorMsg && this.state.errorMsg.length > 0
                             ? <div class="alert alert-danger" role="alert">
                                 {this.state.errorMsg}
                               </div>
                             : "";
  }

  getSuccessNotification(successMsg){
    return this.state.successMsg && this.state.successMsg.length > 0
                            ? <div className="alert alert-success" role="alert">
                                {this.state.successMsg}
                              </div>
                            : "";
  }

  render(){
    return(
      <div className="container">
          {/*<script type="text/javascript" src="https://form.jotform.com/jsform/90355099778170"></script>*/}
          <script type="text/javascript" src="https://form.jotform.com/220714960539459"></script>


      </div>
    )
  }

  renderOLD(){

    return(
      <div className="container">

            <br />
            <div className="row cols-xs-space cols-sm-space cols-md-space">
                  <div className="col-lg-12">
                    <div className="row">
                      <div className="col-lg-2"></div>
                      <div className="col-lg-8 profile-udpate-widget">
                          <div className="card">
                              <div className="card-title b-xs-bottom">
                                  <h3 className="heading heading-sm text-uppercase">Upload Your Presentation For Retnet India Meet 2019</h3>
                              </div>

                              <div className="card-body">
                              {this.getErrorElement()}
                              {this.getSuccessNotification()}

                              <form className="form-default" onSubmit={this.handleSubmit}>
                                    <div className="form-group">
                                        <label>Full Name</label>
                                        <input type="text" id="fullname" onChange={this.handleChange}
                                            className="form-control form-control-lg input-mask"
                                            placeholder="" />
                                    </div>
                                    <div className="form-group">
                                        <label>Email Id</label>
                                        <input type="email" id="email" onChange={this.handleChange}
                                            className="form-control form-control-lg input-mask"
                                            placeholder="" />
                                    </div>
                                    <div className="form-group">
                                        <label>Presentation Topic</label>
                                        <input type="text" id="title" onChange={this.handleChange}
                                            className="form-control form-control-lg input-mask"
                                            placeholder="" />
                                    </div>


                                    <div className="checkbox">
                                     <input type="checkbox"
                                            name="isVideo"
                                            onChange={this.handleIsVideoChange}
                                            checked={this.state.isVideoUI}
                                            id="isVideo" />
                                       <label for="isVideo">
                                           Video Attachment
                                      </label>
                                    </div>

                                     <div className="form-group">
                                         <label htmlFor="file-1">Upload Your Presentation (Video / Images): &nbsp; &nbsp; </label>
                                         <input type="file" name="file-1[]"
                                                 id="file-1"
                                                 accept="image/*,audio/*,video/*,application/*"
                                                 onChange={this.handleFileChange} multiple/>
                                     </div>
                                     <br />
                                     <div className="form-group align-center">
                                         <LoaderButton block bsStyle="primary" bsSize="large"
                                              disable={!this.validateForm()} type="submit"
                                              isLoading={this.state.isLoading} text="Submit"
                                              loadingText="Uploading..."
                                              className="btn btn-primary"/>
                                     </div>
                                     <span className="text-primary"><u>Note:</u></span><br />
                                     <span className="text-primary">Please upload zip files if you have multiple video files</span> <br/>
                                     <span className="text-primary">Each attachment cannot be more than 20 MB</span> <br/>
                                     <span className="text-primary">Attach only mp4 format videos</span> <br/>
                                     <span className="text-primary">Only one video attachment is allowed. Images can be one or more</span>


                              </form>


                              </div>
                          </div>
                      </div>
                      <div className="col-lg-2"></div>
                    </div>

                  </div>
            </div>
            <br />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/SubmitPresentation.js